import { authGet } from './authMiddleware';

export const getPeopleFilters = async () => {
    return authGet('/api/People/start')
}